import { forwardRef } from "react";
import { DatePicker as AntDatePicker } from "@formily/antd-v5";
import dayjs, { Dayjs } from "dayjs";

type DatePickerComponentProps = React.ComponentProps<typeof AntDatePicker>;

type DatePickerProps = Omit<DatePickerComponentProps, "disabledDate"> & {
  disabledDate?: (date: Dayjs) => boolean;
  showFuture?: boolean;
  showPast?: boolean;
};

/**
 * A DatePicker component with optional logic to disallow past or future dates.
 */
export const DatePicker = forwardRef<unknown, DatePickerProps>(
  (
    {
      showFuture = true,
      showPast = true,
      disabledDate: userDisabledDate,
      ...restProps
    },
    ref,
  ) => {
    if ((!showFuture || !showPast) && userDisabledDate)
      console.warn(
        "The 'disabledDate' prop will override 'showFuture' or 'showPast'.",
      );

    const mergedDisabledDate = (current: Dayjs) => {
      if (!current) return false;
      const now = dayjs();
      const blockFuture = !showFuture && current.isAfter(now, "day");
      const blockPast = !showPast && current.isBefore(now, "day");
      const userBlocked = userDisabledDate?.(current) ?? false;
      return blockFuture || blockPast || userBlocked;
    };

    return (
      <AntDatePicker
        ref={ref}
        {...restProps}
        disabledDate={mergedDisabledDate}
      />
    );
  },
);
